const getCookieName = (cookie: string): string => {
  const trimmedCookie = cookie.trim();
  const equalSignIndex = trimmedCookie.indexOf('=');
  return equalSignIndex > -1 ? trimmedCookie.substring(0, equalSignIndex) : trimmedCookie;
};

const deleteCookie = (name: string): void => {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
};

export const deleteLocalAndSessionStorageAndCookies = () => {
  localStorage.clear();
  sessionStorage.clear();

  document.cookie.split(';').map(getCookieName).filter(Boolean).forEach(deleteCookie);
};
